import './scripts/common';
import {onFind} from '@elements/init-modules-in-scope';
import {find} from '@elements/dom-utils';
import {add} from '@elements/scroll-animations';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as filter from "./scripts/filter.js";
filter.init();

import * as triggerSubmit from './scripts/trigger-submit';
triggerSubmit.init();

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init();

import * as fileInput from '@elements/file-input';
fileInput.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as iconScrollAnimation from './scripts/icon-scroll-animation';
iconScrollAnimation.init();

import * as affix from './scripts/elements-packages/affix';
affix.createAffix(find('.js-affix-sidebox'), {mediaQuery: '(min-width: 768px)'}, {
    base: '.js-affix-sidebox',
    placeholder: '.js-affix-sidebox__placeholder',
    container: '.js-affix-sidebox__container'
});

import * as landingpageNav from './scripts/landingpage-nav';
landingpageNav.init();



